import styled from "styled-components";

export const PlayItemWrapper = styled.div`
    .play-block{
        background-color: #F3F3F3;
        padding: 10px;
    }
`

